import {
  BasketRowsGroup,
  BasketRowsGroupType,
} from 'graphql-api/baskets-api-interfaces';

export const isGroupOfType =
  (type: BasketRowsGroupType) => (basketGroup: BasketRowsGroup) =>
    basketGroup.type === type;

export const isAddressGroup = isGroupOfType(BasketRowsGroupType.Address);

export const isDeliveryGroup = isGroupOfType(BasketRowsGroupType.Delivery);

export const isBrandGroup = isGroupOfType(BasketRowsGroupType.Brand);

export const isOrderNumberGroup = isGroupOfType(
  BasketRowsGroupType.OrderNumber,
);

export const isCategoryGroup = isGroupOfType(BasketRowsGroupType.Category);
